import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { SVButton } from './core';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { SVButtonProps } from '@/types/common';

type FormSubmissionButtonsProps = {
  isLoading: boolean;
  onLeave?: () => void;
  submitButtonProps?: SVButtonProps;
  submitButtonLabel?: string;
};

export default function FormSubmissionButtons({
  isLoading,
  onLeave,
  submitButtonProps,
  submitButtonLabel = 'Save',
}: FormSubmissionButtonsProps) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const handleLeave = () => {
    setOpen(false);
    if (onLeave) {
      onLeave();
    } else {
      navigate(-1);
    }
  };

  const handleStay = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isLargeScreen ? 'row' : 'column',
        gap: 2,
      }}>
      <SVButton onClick={() => setOpen(true)} variant="tertiary">
        Back
      </SVButton>
      <SVButton {...submitButtonProps} isLoading={isLoading} type="submit">
        {submitButtonLabel}
      </SVButton>
      <Dialog fullWidth open={open} onClose={handleStay}>
        <DialogContent>
          <Box>
            <Typography variant="h6" component="h2">
              Are you sure you want to leave?
            </Typography>
            <Typography sx={{ mt: 2 }}>
              You will lose unsaved changes on this page
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <SVButton onClick={handleLeave} variant="tertiary">
            Leave
          </SVButton>
          <SVButton onClick={handleStay}>Stay</SVButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
